import React, { memo } from 'react'
import { SPOT_BIDDING_RULES_COLUMNS } from 'apps/spot-quote-control-panel/types/spotBiddingConfig'
import { TableHead, TableRow, TableCell } from 'transfix-ui'

interface ISpotBiddingRulesHeaderProps {
  readOnly?: boolean
}

export const SpotBiddingRulesHeader = memo<ISpotBiddingRulesHeaderProps>(({ readOnly }) => (
  <TableHead>
    <TableRow tableCellType='th'>
      {Object.entries(SPOT_BIDDING_RULES_COLUMNS).map(([key, value]) => (
        <TableCell
          tableCellType='th'
          dataTest={`${key}-column-header`}
          key={`${key}-column-header`}>
          <div className='rule-header'>{value}</div>
        </TableCell>
      ))}
      {!readOnly && (
        <TableCell>
          <div className='fr'>Actions</div>
        </TableCell>
      )}
    </TableRow>
  </TableHead>
))
